<template>
  <el-dialog title="修改密码" :width="'500px'" :visible.sync="dialogVisible" append-to-body>

    <el-form ref="formRef" :model="formData" :rules="formRules">

      <el-form-item label="旧密码" prop="oldPassword">
        <el-input v-model="formData.oldPassword" type="password" placeholder="请输入旧密码"></el-input>
      </el-form-item>

      <el-form-item label="新密码" prop="newPassword1">
        <el-input v-model="formData.newPassword1" type="password" placeholder="请输入新密码"></el-input>
      </el-form-item>

      <el-form-item label="确认新密码" prop="newPassword2">
        <el-input v-model="formData.newPassword2" type="password" placeholder="请输入确认新密码"></el-input>
      </el-form-item>

    </el-form>

    <div slot="footer">
      <el-button type="primary" :loading="submitIng" @click="onClickSubmitBtn">确定</el-button>
    </div>

  </el-dialog>
</template>

<script>
import {removeToken} from '@/utils/auth';
import {ApiChangePassword} from "@/api/user/user";
import {encryptByWeb} from "@/utils/xysPasswordUtil";

export default {
  name: 'ChangePasswordDialog',
  data(){
    return {
      dialogVisible: false,
      submitIng: false,
      formData: {
        oldPassword: '',
        newPassword1: '',
        newPassword2: ''
      },
      formRules: {
        oldPassword: [{required: true, message: '请输入旧密码', trigger: 'blur'}],
        newPassword1: [{required: true, message: '请输入新密码', trigger: 'blur'}],
        newPassword2: [{required: true, message: '请输入确认密码', trigger: 'blur'}],
      },
    }
  },
  mounted(){
  },
  methods: {
    start(){
      this.formData = {
        oldPassword: '',
        newPassword1: '',
        newPassword2: ''
      }
      this.dialogVisible = true
    },
    onClickSubmitBtn(){
      this.$refs.formRef.validate(valid => {
        if (!valid) {
          return
        }

        if (this.formData.newPassword1 !== this.formData.newPassword2) {
          this.$message.error({message: '两次密码不一致', duration: 1500})
          return;
        }

        let data = {
          oldPassword: encryptByWeb(this.formData.oldPassword),
          newPassword: encryptByWeb(this.formData.newPassword1),
        }
        this.submitIng = true
        ApiChangePassword(data).then(() => {
          this.$message.success({message: '修改成功', duration: 1500})
          this.dialogVisible = false
          this.$router.replace({path: '/login'}); // 使用路由跳转
          removeToken();
        }).finally(() => {
          this.submitIng = false
        })
      })
    }

  }
}
</script>

<style lang="scss" scoped>
</style>
